import App from './App.svelte';

const app = new App({
  target: document.body,
  props: {
    jsonFile: 'data.json'
  }
});

export default app;